module.exports = __webpack_public_path__ + "img/Stocksy_Delivery_Driver_Back_of_Van.325535ca.jpg";